import type { ReactNode } from "react";
import classNames from "classnames";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import styles from "./PickerCellTrigger.module.scss";

/**
 * The cell trigger's single-line label; a string ellipsizes with a tooltip.
 * The box takes the free width so the trailing cluster (clear slot, chevron)
 * pins to the cell's right edge like the cell input preset.
 */
export const CellLabel = ({
    label,
    isPlaceholder,
}: {
    label: ReactNode;
    isPlaceholder: boolean;
}) => {
    const labelClassName = classNames(styles.cellLabel, {
        [styles.cellLabelPlaceholder]: isPlaceholder,
    });

    return (
        <span className={styles.cellLabelBox}>
            {typeof label === "string" ? (
                <BreakableText
                    text={label}
                    showTooltip
                    className={classNames(labelClassName, styles.cellLabelText)}
                />
            ) : (
                <span className={labelClassName}>{label}</span>
            )}
        </span>
    );
};
